import React from 'react';
import { PurchaseLot } from '../../../../../../types/entities.js';
import DescriptionList from '../../../../components/DescriptionList.js';
import DescriptionListItem from '../../../../components/DescriptionListItem.js';
import { LotParamValue } from '../../../../LotParams/LotParamValue.js';

interface Props {
  lot: PurchaseLot;
}

const LotParams: React.FC<Props> = ({ lot }) => {
  if (!lot.params || !lot.params.length) {
    return null;
  }

  return (
    <>
      <h3>Дополнительные параметры</h3>
      <DescriptionList>
        <DescriptionListItem
          title="Наименование"
          definition="Желаемое значение"
        />

        {lot.params.map((param) => (
          <DescriptionListItem
            key={param.id}
            title={param.name}
            definition={
              <LotParamValue type={param.type} value={param.desiredValue} />
            }
          />
        ))}
      </DescriptionList>
    </>
  );
};

export default React.memo(LotParams);
